<template>
  <div>
    <FITTextInput :label="$t('crm.lead.search')" :placeholder="$t('crm.lead.keywords')" :width="10" v-model="keywords"></FITTextInput>
    <b-table class="pointer-cursor" outlined fixed hover responsive :items="data.list" :fields="fields" @row-dblclicked="onRowDoubleCliecked">
      <template slot="dateOfContact" slot-scope="row">
        {{ row.value | date }}
      </template>
      <template slot="name" slot-scope="row">
        {{ row.value }}
      </template>
      <template slot="status" slot-scope="row">
        {{ getConvertedString('leadStatus', row.value) }}
      </template>
    </b-table>
    {{data.total}}
    <FITPagination :totalRows="data.total" size="md" :perPage="pagination.perPage" @input="onPageChanged"></FITPagination>
  </div>
</template>
<script>
import {
  FITTextInput,
  FITPagination
} from '@/components'

import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'LeadQuickSearch',
  components: {
    FITTextInput,
    FITPagination
  },

  props: {
    callback: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      keywords: '',
      timeout: null,
      busy: false,
      data: {
        total: 0,
        list: []
      },
      pagination: {
        currentPage: 0,
        perPage: 20
      },

      fields: [
        { key: 'dateOfContact', label: this.$t('crm.lead.create.dateOfContact') },
        { key: 'name', label: this.$t('crm.lead.create.name') },
        { key: 'status', label: this.$t('crm.lead.create.status') }
      ]
    }
  },

  watch: {
    keywords() {
      if (this.busy) {
        return;
      }

      Vue.set(this, 'busy', true);
      if (timeout) {
        clearTimeout(this.timeout);
      }

      let timeout = setTimeout(() => {
        Vue.set(this, 'busy', false);
        Vue.set(this, 'timeout', null);
      }, 500);

      this.refreshPage();
    }
  },

  computed: {
    ...mapGetters('Crm', [
      'getTranslated'
    ]),

    leadStatus() {
      return this.getTranslated(this.$i18n.locale, 'status');
    }
  },

  methods: {

    onPageChanged(newPage) {
      Vue.set(this.pagination, 'currentPage', newPage);
      this.refreshPage();
    },

    refreshPage() {
      this.$store.dispatch('Crm/getLeadList', {
          search: this.keywords,
          count: this.pagination.perPage,
          page: this.pagination.currentPage
        }).then((json) => {
          console.debug(json);
          Vue.set(this, 'data', json.data);
          Vue.set(this, 'busy', false);
        })
        .catch((err) => {
          console.error(err);
        })
    },

    onRowDoubleCliecked(item, index, evt) {
      if (this.callback) {
        this.callback(item);
      }
    },

    getConvertedString(key, value) {
      let result = this[key].filter((item) => {
        return item.text;
      });

      if (result.length > 0) {
        return result[0].text;
      }

      return 'N/A';
    }

  }
}

</script>
<style>
.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/Crm/components/Lead/LeadQuickSearch.vue